export default __webpack_public_path__ + "static/media/login.30c85ad0.svg";